export const LIST_STATE = 'LIST_STATE';
export const LIST_CITY = 'LIST_CITY';
export const LIST_DISTRICT = 'LIST_DISCTRICT';
export const LIST_DEVELOPERS = 'LIST_DEVELOPERS';
export const FILTER_LIST_ENTERPRISE_PERSONAL = 'FILTER_LIST_ENTERPRISE_PERSONAL';
